<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form" @submit.native.prevent="onSubmit">
            <el-form-item label="asin：" class="query-form-item">
                <el-input v-model="query.asin" placeholder="请输入asin"></el-input>
            </el-form-item>
            <el-form-item label="标题：" class="query-form-item">
                <el-input v-model="query.title" placeholder="请输入标题"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit" native-type="submit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :height="tableHeight"
            v-loading="loading"
            :data="list"
            stripe border style="width: 100%">
            <el-table-column prop="id" label="ID" width="100" align="center">
            </el-table-column>
            <el-table-column label="商品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <table-asin-column></table-asin-column>

            <el-table-column label="销售国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="scope.row.category_state.toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="标题" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>

            <el-table-column label="采购状态" width="100" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.purchase_status == 0 ? '选品中' : scope.row.purchase_status == 1 ? '采购中' : '采购完成' }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="创建人员" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.creator_username }} <br/>
                        {{ scope.row.creator_full_name }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="采购人员" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.developer_username }} <br/>
                        {{ scope.row.developer_full_name }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="创建类型" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.manager_cost_analysis_task_id == null ? '自建' : '管理员创建'}} <br/>
                    </div>
                </template>
            </el-table-column>

<!--            <el-table-column-->
<!--                label="操作"-->
<!--                align="center"-->
<!--                fixed="right"-->
<!--                width="220">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button v-show="scope.row.source_path" type="primary" size="mini"-->
<!--                               @click="downFile(scope.row.source_path)">下载-->
<!--                    </el-button>-->
<!--                    <el-button type="success" size="mini" @click.native="handleDetail(scope.$index, scope.row)">详情-->
<!--                    </el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>


        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>

    </div>

</template>

<script>
    import {downloadFileUrl} from '@/utils/method'
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        data() {
            return {
                tableHeight: null,
                addSubLibraryModal: false,
                query: {
                    asin: '',
                    title: '',
                    page: 1,
                    limit: 20
                },
                list: [],
                total: 0,
                loading: true,
                authList: [],
                defaultProps: {
                    children: 'children',
                    label: 'title'
                },
                authLoading: false,
                authFormVisible: false,
                authFormData: {
                    role_id: '',
                    auth_rules: []
                },
                authDefaultCheckedKeys: [],
                index: null,
                formName: null,
                formMap: {
                    add: '新增角色',
                    edit: '编辑'
                },
                formLoading: false,
                formVisible: false,
                formRules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'change'}
                    ]
                },
                deleteLoading: false
            }
        },
        methods: {
            handleDetail(index,data) {
                this.$refs.shipmentDetailRef.showModal(data)
            },
            // 关闭弹窗回调
            closeCllback(isShow) {
                this.addSubLibraryModal = false
                isShow == true && this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            onReset() {
                this.query = {
                    asin: '',
                    title: '',
                    page: 1,
                    limit: 20
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            uploadFunc() {
                this.addSubLibraryModal = true
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                api.extra_dealt_asin_query_query(this.query)
                    .then(response => {
                        this.loading = false
                        this.list = response.data.list || []
                        this.total = response.data.total || 0
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                    })
            },
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        created() {
            // 加载表格数据
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
</style>
